// eslint-disable-next-line import/no-anonymous-default-export
export const color = {
  WHITE: "#FFFFFF",
  FHGREEN: "#338F86",
  // Darker brand teal for TEXT on white backgrounds. FHGREEN (#338F86) has a
  // 3.88:1 contrast ratio on white — below the WCAG AA 4.5:1 minimum for
  // normal-size text (axe: color-contrast, serious). This shade measures
  // 5.23:1. Keep FHGREEN for fills/borders/large text; use this for links
  // and body-size text on light backgrounds.
  FHGREEN_TEXT: "#2A7870",
  TEXTGREY: "#4F566B",
  FHADMIN: "#3786D6",
  ADMINHEADING: "#595959",
  DISABLED: "#cccccc",
  REJECT: "#FF0000",
  LOANTEXT: "#31332C",
  GREYBG: "#D9DCE1",
  BGGREY: "#D9DCE1",
  primaryButtonBackground: "#333",
  primaryButtonText: "#fff",
  agreementFont: "#338F86",
  greyColor: "#cccccc",
  whiteColor: "#FFFFFF",
  darkGreyColor: "#979797",
};

// Sidebar / mobile drawer surface. Deep brand green — the same panel colour the
// accredited-investor chip sits on, so the nav and the chip read as one system.
export const SIDEBAR_DARK = "#12332E";
// Nav link pill text — same slate colour at rest and on hover; only the
// background tints on hover, so hovering doesn't change how the text reads.
export const NAV_LINK_TEXT = "#475569";
export const NAV_LINK_BG = "#FFFFFF";
// Nav link icon — same slate-grey at rest and on hover, one shade darker
// than the label so the two still read as a pair.
export const NAV_LINK_ICON = "#64748B";
// Pale mint tint behind a nav link on hover AND for the current route —
// only the icon/text colour tells the two states apart.
export const NAV_LINK_TINT_BG = "#DBF1EF";
// Current-route icon + text — brand teal, distinct from the resting slate.
export const NAV_LINK_SELECTED_ICON = "#007A70";
export const NAV_LINK_SELECTED_TEXT = "#007A70";
